import { Breadcrumbs, Button, Stack, Typography } from '@mui/material';
import { ArrowLeft } from '@phosphor-icons/react';
import { useNavigate } from 'react-router';

type Props = {
  title: string;
  items?: Array<{
    name: string;
    url?: string;
  }>;
};

export default function HeaderBreadcrumbs({ title, items }: Props) {
  const navigate = useNavigate();

  return (
    <Stack gap={0.5}>
      {items && (
        <Breadcrumbs>
          {items.map((link, index) => {
            const isOnlyLink = items.length === 1;

            if (link.url) {
              return (
                <Button
                  key={index}
                  variant="text"
                  onClick={() => navigate(link.url!)}
                  color="inherit"
                >
                  <Stack direction="row" alignItems="center" gap={0.5}>
                    {isOnlyLink && <ArrowLeft />}
                    <Typography>{link.name}</Typography>
                  </Stack>
                </Button>
              );
            } else {
              return (
                <Typography key={index} color="primary">
                  {link.name}
                </Typography>
              );
            }
          })}
        </Breadcrumbs>
      )}
      <Typography variant="h4" component="h1">
        {title}
      </Typography>
    </Stack>
  );
}
